<template>
  <div class="col-span-2 flex flex-col">
    <div class="text mb-2 flex flex-col">
      <span class="text txt-muted">
        {{ $t(title) }}
      </span>

      <span class="text text-primary text-lg">{{ statistics.total }}</span>
    </div>

    <table class="information-card__table w-full table-fixed">
      <thead>
        <tr class="text txt-muted">
          <th class="text-left">
            {{ $t('CHATLYN_SUBSCRIPTION.INFORMATION.TABLE.TYPES') }}
          </th>

          <th class="text-right">
            {{ $t('CHATLYN_SUBSCRIPTION.INFORMATION.TABLE.AMOUNT') }}
          </th>

          <th class="text-right">
            {{ $t('CHATLYN_SUBSCRIPTION.INFORMATION.TABLE.COST') }}
          </th>
        </tr>
      </thead>

      <tbody>
        <InformationItem
          v-for="(item, index) in statistics.items"
          :key="index"
          :item="item"
        />
      </tbody>
    </table>
  </div>
</template>

<script>
import InformationItem from 'dashboard/routes/dashboard/settings/subscription/information/InformationItem.vue';

export default {
  name: 'InformationCard',

  components: {
    InformationItem,
  },

  props: {
    title: {
      type: String,
      default: '',
    },

    statistics: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style scoped lang="scss">
.information-card__table {
  &::v-deep {
    th,
    td {
      @apply w-1/3 overflow-hidden text-ellipsis whitespace-nowrap;
    }
  }
}
</style>
